import { Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "./page/Dashboard/Dashboard";
import LoginScreen from "./page/Login/login";
import Students from "./page/Students/Students";
import Profile from "./page/Profile/Profile";
import StudentProfile from "./components/Students/Specificstudent";
import Institutions from "./page/Institutions/Institutions";
import Institutionsspecific from "./components/Institutions/Institutionsspecific";
import Message from "./page/Message/Message";
import ProtectedRoute from "./ProtectedRoute";
import Uploadpage from "./page/Upload/Uploadpage";
import OMRPage from "./components/UploadComponet/OMRPage ";
import Accounts from "./page/Accounts/accounts";
import CMSManagement from "./page/CMSManagement/CMSManagement";
import LegalPage from "./page/Legal/LegalPage";
import VersionControl from "./page/VersionControl/VersionControl";
import { useSelector } from "react-redux";
import Batches from "./page/Batches/Batches";
import BatchDetails from "./components/Batches/BatchDetails";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import LandingPage from "./page/Home/LandingPage";
import PrivacyPolicy from "./page/Legal/PrivacyPolicy";
import TermsOfService from "./page/Legal/TermsOfService";
import InstitutionsStudents from "./page/Students/institutionsstudents";
import InstitutionRevenuePage from "./page/Revenue/InstitutionRevenuePage";
import InstitutionDashboardPage from "./page/Dashboard/InstitutionDashboardPage";
import ApprovalPage from "./page/Approval/ApprovalPage";
const AppRoutes = () => {
  const { token, roleType, userId } = useSelector((state) => state.auth);
  const location = useLocation();
  const isAdminLogin = roleType === "superadmin";
  const isAuthenticated = userId;
  // localStorage.setItem(roleType, "roleType");
  // const lastroletype = localStorage.getItem(roleType, "roleType");
  // const Logoutpath =
  //   lastroletype === "superadmin" ? "/admin/login" : "/institutions/login";

  const navigate = useNavigate();
  useEffect(() => {
    // Only redirect if NOT on public routes and NOT authenticated
    const publicRoutes = ["/", "/admin/login", "/institutions/login", "/institutions/signup", "/privacy", "/terms"];
    if (!isAuthenticated && !publicRoutes.includes(location.pathname)) {
      navigate("/institutions/login");
    }

    // Redirect logged-in users from root to their dashboard
    if (isAuthenticated && location.pathname === "/") {
      if (isAdminLogin) {
        navigate("/admin/dashboard");
      } else {
        navigate("/institution/dashboard");
      }
    }
  }, [isAuthenticated, location.pathname, isAdminLogin]);

  return (
    <Routes>
      <Route path="/admin/login" element={<LoginScreen />} />
      <Route path="/institutions/login" element={<LoginScreen />} />
      <Route path="/institutions/signup" element={<LoginScreen />} />
      {/* 
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      /> */}
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/institution/dashboard"
        element={
          <ProtectedRoute>
            <InstitutionDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/upload"
        element={
          <ProtectedRoute>
            <Uploadpage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/students"
        element={
          <ProtectedRoute>
            <Students />
          </ProtectedRoute>
        }
      />

      <Route
        path="/approval"
        element={
          <ProtectedRoute>
            <ApprovalPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/students/profile/student/:studentId/institute/:institutionId/batchId/:batchId"
        element={
          <ProtectedRoute>
            <StudentProfile />
          </ProtectedRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />

      <Route
        path="/institutions"
        element={
          <ProtectedRoute>
            <Institutions />
          </ProtectedRoute>
        }
      />

      <Route
        path="/institution/:id"
        element={
          <ProtectedRoute>
            <Institutionsspecific />
          </ProtectedRoute>
        }
      />

      <Route
        path="/cms"
        element={
          <ProtectedRoute>
            <CMSManagement />
          </ProtectedRoute>
        }
      />

      <Route
        path="/version-control"
        element={
          <ProtectedRoute>
            <VersionControl />
          </ProtectedRoute>
        }
      />

      <Route
        path="/message"
        element={
          <ProtectedRoute>
            <Message />
          </ProtectedRoute>
        }
      />
      <Route
        path="/message/:id/:name"
        element={
          <ProtectedRoute>
            <Message />
          </ProtectedRoute>
        }
      />

      <Route
        path="/batches"
        element={
          <ProtectedRoute>
            <Batches />
          </ProtectedRoute>
        }
      />
      <Route
        path="/batches/details/:batchId"
        element={
          <ProtectedRoute>
            <BatchDetails />
          </ProtectedRoute>
        }
      />

      <Route
        path="/institution/students"
        element={
          <ProtectedRoute>
            <InstitutionsStudents />
          </ProtectedRoute>
        }
      />
      <Route
        path="/institution/revenue"
        element={
          <ProtectedRoute>
            <InstitutionRevenuePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/omr"
        element={
          <ProtectedRoute>
            <OMRPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/omr/batches"
        element={
          <ProtectedRoute>
            <OMRPage />
          </ProtectedRoute>
        }
      />


      <Route
        path="/accounts"
        element={
          <ProtectedRoute>
            <Accounts />
          </ProtectedRoute>
        }
      />
      <Route
        path="/legal"
        element={
          <ProtectedRoute>
            <LegalPage />
          </ProtectedRoute>
        }
      />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
    </Routes>
  );
};

export default AppRoutes;
